export interface AccountManagerInfo {
  id: string
  email: string
  fullName: string | null
}

export interface RosterConnectionInfo {
  id: string
  provider: string
  accountsCount: number
  districtExternalId: string
  districtName: string | null
  enabled: boolean
  archiveEnabled: boolean
  archiveThresholdPercent: number
  settings: Record<string, unknown>
  lastSyncedAt: string | null
}

export type RosterSyncRunStatus =
  | 'pending'
  | 'processing'
  | 'completed'
  | 'completed_with_errors'
  | 'failed'
  | 'cancelled'

export interface RosterSyncRun {
  id: string
  status: RosterSyncRunStatus
  dryRun: boolean
  forceArchive: boolean
  startedAt: string | null
  finishedAt: string | null
  counters: Record<string, number>
  result: Record<string, unknown>
  createdAt: string
}

export interface RosterConnectionDetail extends RosterConnectionInfo {
  recentRuns: RosterSyncRun[]
}

export interface RosterSyncFailure {
  severity: 'warning' | 'error'
  recordType: string
  externalId: string | null
  schoolExternalId: string | null
  reasonCode: string
  payload: Record<string, unknown>
}

export interface RosterSyncRunDetail extends RosterSyncRun {
  failures: RosterSyncFailure[]
  failuresTotal: number
}

export interface AccountSchool {
  id: string
  name: string
  schoolType: string | null
}

export interface AdminAccount {
  id: string
  name: string
  createdAt: string
  schoolsCount: number
  schools: AccountSchool[]
  managers: AccountManagerInfo[]
  rosterConnection: RosterConnectionInfo | null
}

/** Pagy metadata (camelized by the axios interceptor). */
export interface PaginationMeta {
  page: number
  pages: number
  count: number
}

export interface AccountsPage {
  accounts: AdminAccount[]
  pagination: PaginationMeta | null
}

export interface ConnectionFormValues {
  districtExternalId: string
  districtName: string
}

export interface ConnectionSettingsValues {
  enabled: boolean
  archiveEnabled: boolean
  archiveThresholdPercent: number
}

export const ACTIVE_RUN_STATUSES: RosterSyncRunStatus[] = ['pending', 'processing']
